// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"Accordion_maxWidth__pyt6D","heading":"Accordion_heading__3ipcM","Accordion":"Accordion_Accordion__39OKi"};